export default __webpack_public_path__ + "static/media/users.d042cf78.png";